module.exports = __webpack_public_path__ + "static/media/print-icon.32d391e1.svg";